import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import { useCartState } from 'public/context/CartContext';
import { StyledWholesaleDelivery } from './style';
import WholesaleDeliveryDrawer from './WholesaleDeliveryDrawer';

const WholesaleDelivery = () => {
  const intl = useIntl();
  const { wholesaleDeliveryMode, wholesaleDeliveries } = useCartState();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const hasDeliveryConfigured =
    wholesaleDeliveryMode && wholesaleDeliveries && wholesaleDeliveries.length > 0;

  return (
    <StyledWholesaleDelivery>
      <Button
        className={`delivery-button${hasDeliveryConfigured ? ' delivery-configured' : ''}`}
        icon={<Icon name={hasDeliveryConfigured ? 'car-delivery-black' : 'car-delivery'} />}
        onClick={() => setDrawerOpen(true)}
        label={intl.formatMessage({
          id: hasDeliveryConfigured
            ? 'wholesale.delivery.change_method'
            : 'wholesale.delivery.label',
        })}
      />
      <WholesaleDeliveryDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </StyledWholesaleDelivery>
  );
};

export default WholesaleDelivery;
